import React, { useState, useEffect, useRef } from 'react';
import '../styles/profile.css';
import { FaUserCircle, FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function Profile() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const sidebarRef = useRef(null);
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isAmountVisible, setIsAmountVisible] = useState(true);
    const [accountBalance, setAccountBalance] = useState(null);
    const [userData, setUserData] = useState(null);
    const toggleAmountVisibility = () => {
        setIsAmountVisible(prevState => !prevState);
    };

    // Fetch the account balance from the API (simulated with dummy data)
    useEffect(() => {
        const fetchAccountBalance = async () => {
            // Simulating a delay to fetch the dummy balance
            setTimeout(() => {
                const dummyBalance = 392740; // Match the screenshot balance
                setAccountBalance(dummyBalance);
            }, 1000); // Simulated delay of 1 second
        };

        fetchAccountBalance();
    }, []);


    const fetchUserBalance = async (username) => {
        if (!username) return;  // Prevent API call if username is missing
        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${baseUrl}/wallet/username/${username}`);
            const data = await response.json();
            if (data && data.amount !== undefined) {
                setUserData(prev => ({ ...prev, amount: data.amount })); // Store the correct amount
            }
        } catch (error) {
            console.error('Error fetching user balance:', error);
        }
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);  
                fetchUserBalance(parsedUser.username);
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }
    }, []);

    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setSidebarOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const AccountBalance = ({ isAmountVisible, toggleAmountVisibility, balance, user }) => {
        return (
            <div className="account-balance-container">
                <div className="account-balance-header">
                    <div className="profile-containers">
                        <FaUserCircle className="profile-icon" />
                        <span className="username">{user ? user.username : 'Guest'}</span>
                        <span className="notification-badge">!</span> {/* Notification badge */}
                    </div>
                    <div className="balance-title-container">
                        <h2 className="balance-title">
                            Overall Account Balance(US-Dollar)
                        </h2>
                        <button onClick={toggleAmountVisibility} className="visibility-button">
                            {isAmountVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </button>
                    </div>
                    <div className="balance-container">
                        <h1 className="balance-amount">
                            <span>{isAmountVisible ? `$${(userData?.amount || 0).toLocaleString()}` : '*********'}</span>
                        </h1>
                        <p className="approximate-amount">
                            {isAmountVisible ? `≈ ${(userData?.amount || 0).toLocaleString()}` : '≈ *********'}
                        </p>
                    </div>

                </div>
            </div>
        );
    };

    return (
        <div className="profile-page">
            <div className={`profile-container ${sidebarOpen ? 'shifted' : ''}`}>
                <AccountBalance
                    isAmountVisible={isAmountVisible}
                    toggleAmountVisibility={toggleAmountVisibility}
                    balance={accountBalance || 0}
                    user={user} // Pass user as a prop to AccountBalance
                />
                <div className="operation-section">
                    <div className="operation-left">
                        <div className="operation-deposit" onClick={() => navigate('/deposit')}>
                            <span className="card-icon">
                                <FaArrowDown style={{ color: "white" }} />
                            </span>
                            <span className="deposit-card-text">DEPOSIT</span>
                        </div>
                        <div className="operation-card" onClick={() => navigate('/walletransaction')}>
                            <span className="card-icon">📜</span>
                            <span className="card-text">Transaction history</span>
                        </div>
                        <div className="operation-card" onClick={() => navigate('/staking')}>
                            <span className="card-icon">📊</span>
                            <span className="card-text">DeFi Staking</span>
                        </div>
                        <div className="operation-card" onClick={() => navigate('/livechat')}>
                            <span className="card-icon">💬</span>
                            <span className="card-text">Live Chat</span>
                        </div>
                    </div>
                    <div className="operation-right">
                        <div className="operation-withdraw" onClick={() => navigate('/widthdrawall')}>
                            <span className="card-icon">
                                <FaArrowUp style={{ color: "black" }} />
                            </span>
                            <span className="withdraw-card-text">WITHDRAWAL</span>
                        </div>
                        <div className="operation-card" onClick={() => navigate('/tradehistory')}>
                            <span className="card-icon">📈</span>
                            <span className="card-text">Trade History</span>
                        </div>
                        <div className="operation-card" onClick={() => navigate('/news')}>
                            <span className="card-icon">📰</span>
                            <span className="card-text">News</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;
